<template>
  <transition name="rt-zoom-target">
    <div
      v-show="visible"
      ref="tooltip"
      :class="tooltipCalssName"
      :style="tooltipStyle"
    >
      <span class="tooltip-text">{{ text }}</span>
      <div
        ref="arrow"
        class="popper__arrow"
        :class="placement === 'top' ? 'popper__arrow_bottom' : ''"
        :style="arrowStyle"
      ></div>
    </div>
  </transition>
</template>

<script>
export default {
  name: 'RtTooltipGlobal',
  props: {

    // 指定标记的元素
    reference: Object
  },
  data () {
    return {
      visible: false,
      // 自定义背景色
      backgroundColor: 'black',
      effect: 'dark',
      // 自定义透明度
      opacity: 0.7,
      size: 'large',
      // 文字
      text: '',
      placement: 'bottom',
      posiLeft: 0,
      posiTop: 0,
      transLeft: 0,
      transTop: 0,
      arrowRight: 'unset',
      arrowLeft: 'unset'
    };
  },
  computed: {
    tooltipCalssName () {
      let classList = [
        'rt-xpc-tooltip-global',
        'is-dark',
        'el-tooltip__popper',
        'rt-xpc-tooltip-none-border',
        'rt-xpc-box-shadow-light'
      ];
      const bgColor = this.backgroundColor;
      let opacity = Number(this.opacity);
      switch (opacity) {
        case 0.9:
          classList.push(`rt-xpc-tooltip-opacity-nine`);
          break;
        case 0.7:
          classList.push(`rt-xpc-tooltip-opacity-seven`);
          break;
        case 0.5:
          classList.push(`rt-xpc-tooltip-opacity-five`);
          break;
        case 0.3:
          classList.push(`rt-xpc-tooltip-opacity-three`);
          break;
      }

      let size = this.size;
      if (size) {
        classList.push(`rt-xpc-tooltip-size-${size}`);
      }

      classList.push(`rt-xpc-tooltip-${this.placement}-is-${bgColor}`);
      return classList;
    },
    tooltipStyle () {
      const style = {
        left: `${this.posiLeft}px`,
        top: `${this.posiTop}px`,
        'transform-origin': `${this.transLeft} ${this.transTop}`
      };

      return style;
    },
    arrowStyle () {
      return {
        left: this.arrowLeft,
        right: this.arrowRight
      }
    }
  },
  watch: {
    reference () {
      this.update();
    }
  },
  mounted () {
    this.update();
  },
  methods: {
    update () {
      if (this.reference) {
        this.backgroundColor = this.reference.getAttribute('tip-background-color') || 'black';
        this.opacity = this.reference.getAttribute('tip-opacity') || 0.7;
        this.size = this.reference.getAttribute('tip-size') || 'large';
        this.text = this.reference.getAttribute('tip-text') || this.reference.innerText || this.reference.innerHtml;
        this.$nextTick(() => {
          this.positionTip();
        })
      }
    },
    positionTip () {
      const tip = this.$refs.tooltip;
      const {
        bottom,
        top,
        left,
        right,
        width
        // height
      } = this.reference.getBoundingClientRect();
      let posiTop = bottom + 10;
      let posiLeft = left;

      if (width >= tip.clientWidth) {
        posiLeft = left + width / 2 - tip.clientWidth / 2;
        this.arrowLeft = `${tip.clientWidth / 2 - 6}px`;
        this.arrowRight = `unset`;
        this.transLeft = `${tip.clientWidth / 2 - 6}px`;
      } else if (posiLeft + tip.clientWidth >= window.innerWidth) {
        posiLeft = right - tip.clientWidth;
        this.arrowLeft = `unset`;
        this.arrowRight = `${width / 2 - 6}px`;
        this.transLeft = `${tip.clientWidth - width / 2 + 6}px`;
      } else {
        this.arrowLeft = `${width / 2 - 6}px`;
        this.arrowRight = `unset`;
        this.transLeft = `${width / 2 - 6}px`;
      }

      if (posiTop + tip.clientHeight > window.innerHeight) {
        posiTop = top - 10 - tip.clientHeight;
        if (posiTop < 0) posiTop = 0;
        this.placement = 'top';
        this.transTop = `${tip.clientHeight}px`;
      } else {
        this.placement = 'bottom';
        this.transTop = '0px';
      }

      this.posiLeft = posiLeft;
      this.posiTop = posiTop;

      //   const tipRect = tip.getBoundingClientRect();
      //   const transLeft = left + width / 2 - tipRect.left;
      //   const transTop = top + height / 2 - tipRect.top;

    //   this.transLeft = transLeft;
    //   this.transTop = transTop;
    }
  }
};
</script>



// WEBPACK FOOTER //
// rtTooltipGlobal.vue?3826a3a7